var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M868.44-372.48 587.52-91.56q-15.55 15.39-34.99 23.08-19.44 7.7-39.53 7.7t-39.53-7.7q-19.44-7.69-34.99-23.08L91.7-438.35q-14.4-14.39-22.66-33.62-8.26-19.24-8.26-40.46v-281.35q0-43.49 30.97-74.47 30.98-30.97 74.47-30.97h281.35q20.91 0 40.52 8.2 19.61 8.19 34 23.15l346.35 346.22q15.95 15.95 23.43 35.48 7.48 19.52 7.48 39.55 0 20.03-7.48 39.39t-23.43 34.75ZM513-166.78l279.78-279.79L446-793.22H166.78v279.79L513-166.78Zm-247.41-468.7q24.5 0 41.71-17.15 17.22-17.15 17.22-41.65T307.37-736q-17.15-17.22-41.65-17.22T224-736.07q-17.22 17.15-17.22 41.66 0 24.5 17.15 41.71 17.15 17.22 41.66 17.22ZM480-480Z"}));
}

Tag.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = Tag;

Tag.default = Tag;
